import { c as _c } from "react/compiler-runtime";
import { RefObject, useSyncExternalStore } from 'react';
export enum TooltipPosition {
  TOP = 'top',
  LEFT = 'left',
  RIGHT = 'right',
}
const getTooltipPosition = (ref: RefObject<HTMLElement | null>, tooltipWidth: number): TooltipPosition => {
  let position = TooltipPosition.TOP;
  if (typeof window !== 'undefined' && ref.current) {
    const {
      left,
      width
    }: DOMRect = ref.current.getBoundingClientRect();
    const center: number = left + width / 2;
    const halfTooltipWidth: number = tooltipWidth / 2;
    const leftEdge: number = center - halfTooltipWidth;
    const rightEdge: number = center + halfTooltipWidth;
    if (rightEdge > window.innerWidth) {
      position = TooltipPosition.LEFT;
    } else if (leftEdge < 0) {
      position = TooltipPosition.RIGHT;
    }
  }
  return position;
};
export function useTooltipPosition(ref, t0) {
  const $ = _c(5);
  const tooltipWidth = t0 === undefined ? 250 : t0;
  let t1;
  if ($[0] !== ref) {
    t1 = onStoreChange => {
      let unsubscribe = _temp;
      if (typeof window !== "undefined") {
        const currentElement = ref.current;
        const observer = new ResizeObserver(() => {
          onStoreChange();
        });
        if (currentElement) {
          observer.observe(currentElement);
        }
        window.addEventListener("resize", onStoreChange);
        queueMicrotask(onStoreChange);
        unsubscribe = () => {
          window.removeEventListener("resize", onStoreChange);
          if (currentElement) {
            observer.unobserve(currentElement);
          }
          observer.disconnect();
        };
      }
      return unsubscribe;
    };
    $[0] = ref;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== ref || $[3] !== tooltipWidth) {
    t2 = () => getTooltipPosition(ref, tooltipWidth);
    $[2] = ref;
    $[3] = tooltipWidth;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return useSyncExternalStore(t1, t2, _temp2);
}
function _temp2() {
  return TooltipPosition.TOP;
}
function _temp() {}